module.exports = __webpack_public_path__ + "static/media/south_delhi_mun_corp.3c1f1460.png";